/**
 * @param {Object} obj obj
 * @param {String} prefix prefix
 * @returns {Object}
 */
function removePrefixFromParams(obj, prefix) {
  if (!prefix) {
    return obj;
  }

  const newObj = {};

  let key;
  for (key in obj) {
    newObj[key.replace(prefix, '')] = obj[key];
  }

  return newObj;
}

export default removePrefixFromParams;
